import axios from 'axios'

axios.defaults.baseURL = 'https://web.newland.com.cn'

export function fetch_GET (url, params) {
  return axios.get(url, { params: params })
}

export function fetch_POST (url, data) {
  return axios.post(url, data)
}
